import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardText,{staticClass:"pa-8 text-center"},[_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.loadingMessage))}})]),_c(VProgressLinear,{attrs:{"indeterminate":"","color":"primary","height":"8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }